import { getTokens } from 'core/classes/helpers/StorageHelper'
import {
  IGenerateReportArgs,
  IGenerateReportResponse,
  IGenerateReportResponseData,
} from 'partner360/services/report/generateReport'
import settings from 'src/config/settings'

export const generateReports = async (
  payload: IGenerateReportArgs[]
): Promise<IGenerateReportResponse<IGenerateReportResponseData[]>> => {
  const serviceUrl = settings.httpsServices.partner360
    ? settings.httpsServices.partner360
    : 'https://partner360-service-itg.corp.hpicloud.net'

  const [token] = getTokens()
  const url = `${serviceUrl}/api/v0/exportDocument/generateBulk`

  const response = await fetch(url, {
    headers: {
      Authorization: `${token}`,
    },
    method: 'POST',
    body: JSON.stringify(payload),
  })

  const resJson = await response.json()
  const data: IGenerateReportResponseData[] = resJson.data
  return {
    isSuccess: response.ok,
    data: data,
  }
}
